/**
 * Central registry of every release tour that exists, so a future Help-menu "Replay a tour"
 * list can be built generically (map over `getRegisteredTours()`) instead of each menu item
 * being hand-wired to a specific tour. No Help menu exists in the app yet — this is the
 * extensibility point for when one does.
 *
 * Register a tour once, next to its config:
 *   export const CONSENT_MANAGEMENT_TOUR: ReleaseTourConfig = { ... };
 *   registerReleaseTour(CONSENT_MANAGEMENT_TOUR);
 */
import type { ReleaseTourConfig } from './release-tour-types';

const registry = new Map<string, ReleaseTourConfig>();

export function registerReleaseTour(config: ReleaseTourConfig): void {
  registry.set(config.id, config);
}

export function getRegisteredTours(): ReleaseTourConfig[] {
  return Array.from(registry.values());
}
